<div class="drawer-backdrop" *ngIf="slideState === 'open'" (click)="onBackdropClicked()">
</div>
<ng-content select="xux-drawer-sidebar"></ng-content>
<ng-content select="xux-drawer-content"></ng-content>
